export default "icons-arrow-double"